<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">提成设置<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
<!--            <div class="content-input-item">-->
<!--              <label>所属门店</label>-->
<!--              <el-select v-model="shopId" placeholder="Select" class="select-item">-->
<!--                &lt;!&ndash;                <template #prefix>&ndash;&gt;-->
<!--                &lt;!&ndash;                  <p class="select-itm">门店<span>|</span></p>&ndash;&gt;-->
<!--                &lt;!&ndash;                </template>&ndash;&gt;-->
<!--                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
<!--            <div class="content-input-item">-->
<!--              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
<!--            </div>-->
            <div class="content-input-item">
              <label>所属门店</label>
              <el-input v-model="searchValue" placeholder="请输入店铺名称" >
                <template #prefix>
                  <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
                </template>
              </el-input>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
<!--            <div class="content-input-btn">-->
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
<!--        <div class="content-button">-->
<!--          <div>-->
<!--&lt;!&ndash;            <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>&ndash;&gt;-->
<!--          </div>-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--          </div>-->

<!--        </div>-->
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1"></el-table-column>
            <el-table-column property="validDate" label="生效时间" v-if="checkColList.indexOf('生效时间') > -1"/>
            <el-table-column property="shopName" label="店铺名称" v-if="checkColList.indexOf('店铺名称') > -1"></el-table-column>
            <el-table-column property="washing" label="洗澡项目（元）" v-if="checkColList.indexOf('洗澡项目（元）') > -1"></el-table-column>
            <el-table-column property="washingRepurchase" label="复购奖励（元）" v-if="checkColList.indexOf('复购奖励（元）') > -1"></el-table-column>
            <el-table-column property="increment" label="增值服务（%）" v-if="checkColList.indexOf('增值服务（%）') > -1"></el-table-column>
            <el-table-column property="goodSales" label="物品销售（%）" v-if="checkColList.indexOf('物品销售（%）') > -1"></el-table-column>
            <el-table-column property="liveSales" label="活体销售（%）" v-if="checkColList.indexOf('活体销售（%）') > -1"></el-table-column>
            <el-table-column property="other" label="其他（%）" v-if="checkColList.indexOf('其他（%）') > -1"></el-table-column>
            <el-table-column property="userPay" label="客户充值（%）" v-if="checkColList.indexOf('客户充值（%）') > -1"></el-table-column>
            <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="160">
              <template #default="scope">
                <el-button type="primary" @click="bonusEdit(scope.row)" size="small">编辑</el-button>
                <el-button type="warning" @click="bonusHistory(scope.row)" size="small">历史</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {getShopBonusPageList} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo";
import DatePickerRange from "@/components/DatePickerRange";
import RecordList from "@/views/user/components/RecordList";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import BonusEditDialog from "@/views/shop/components/BonusEditDialog";
import BonusHistoryDialog from "@/views/shop/components/BonusHistoryDialog";
import unLock from "@/layout/components/unLock";

export default {
  name: "ShopBonus",
  components: {BtnGroup, SearchComponents, SearchUidOrPhone, UserInfo, DatePickerRange, RecordList , unLock},
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      //刷新组
      colList: ['更新时间', '生效时间',  '店铺名称', '洗澡项目（元）', '复购奖励（元）', '增值服务（%）', '物品销售（%）', '活体销售（%）', '其他（%）', '客户充值（%）', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '称呼', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      idArray: [],
      sort: 2,

      upChargeLoading: false,


    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      // param['shopId'] = this.shopId;
      // param['startTime'] = this.startTime;
      // param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopBonusPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: e,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    bonusEdit(row) {
      let bonusForm = Object.assign({}, row);
      Dialog.open({
        title: '门店【' + row.shopName + '】的提成',
        component: BonusEditDialog,
        data: {
          bonusForm: bonusForm,
          width: '500px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    bonusHistory(row) {
      let bonusForm = Object.assign({}, row);
      Dialog.open({
        title: '门店【' + row.shopName + '】的提成历史',
        component: BonusHistoryDialog,
        data: {
          bonusForm: bonusForm,
          width: '1300px'
        },
        confirm: () => {
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
